// @flow
import type { ComponentType } from 'react';
import React from 'react';

import styles from './cardHeaderIcon.css';

type CardHeaderIconPropTypes = {
  Icon: ComponentType<*>,
};

const CardHeaderIcon = ({
  Icon,
}: CardHeaderIconPropTypes) => <Icon className={styles.icon} size={40} />;


export default CardHeaderIcon;



// WEBPACK FOOTER //
// ./src/scripts/components/CardHeaderIcon/index.jsx